import { UploadFileOutlined as UploadFileOutlinedIcon } from '@mui/icons-material'
import CustomButton from '../../../../../ui/CustomButton'
import ResizableModal from '../../../../../ui/ResizableModal'
import UploadWorkspace from './UploadWorkspace'

const InventoryUploadModal = ({ actions, data, navigation, open, state }) => (
  <ResizableModal
    className='font-sans'
    open={open}
    onClose={navigation.closeUploadModal}
    width={1180}
    height={820}
    minWidth={920}
    minHeight={620}
    size='large'
    footer={
      <CustomButton
        className='rounded-full uppercase text-sm'
        color='primary'
        title='CERRAR'
        onClick={navigation.closeUploadModal}
      />
    }
  >
    <div className='space-y-4'>
      <div className='rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm'>
        <div className='inline-flex items-center gap-2 rounded-full border border-accent2/20 bg-accent2/[0.08] px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-accent2'>
          <UploadFileOutlinedIcon style={{ fontSize: '0.9rem' }} />
          Carga Excel
        </div>
        <h3 className='mt-2 text-xl font-semibold text-slate-950 md:text-[1.45rem]'>
          Importa catálogo o stock inicial
        </h3>
        <p className='mt-1 max-w-2xl text-sm leading-5 text-slate-600'>
          Revisa el formato esperado y procesa la carga sin salir de la pantalla actual.
        </p>
      </div>

      <UploadWorkspace actions={actions} data={data} navigation={navigation} state={state} />
    </div>
  </ResizableModal>
)

export default InventoryUploadModal
